import { NgModule } from '@angular/core';
import { translationChunksConfig, translationsEn } from "@spartacus/assets";
import { ConfigModule, FeaturesConfig, I18nConfig, OccConfig, provideConfig, provideConfigFactory, SiteContextConfig } from "@spartacus/core";
import {
  defaultCmsContentProviders, mediaConfig,
  OutletPosition,
  provideOutlet,
} from "@spartacus/storefront";
import { KbsSiteDocSearchPageComponent } from './custom-feature/kbs-site-doc-search-page/component/kbs-site-doc-search-page.component';
import { CustomLayoutConfig } from './layout-config';
import { FooterComponent } from './custom-feature/common/components/footer/footer.component';

@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfig({
      pagination: {
        startLabel: 'Prev',
        previousLabel: 'Prev',
        nextLabel: 'Next',
        rangeCount: 5,
        addNext: true,
        addEnd: false,
        addPrevious: true,
        addStart: false,
        //addPrevious:true
      },
    }),
  ],
  providers: [provideConfig(CustomLayoutConfig),
  provideConfig(mediaConfig),
  ...defaultCmsContentProviders,
  provideConfig(<OccConfig>{
    backend: {
      occ: {
      }
    },
  }),
  provideConfig(<SiteContextConfig>{
    context: {
      baseSite: ['KBS'],
      language: ['en'],
      currency: ['USD']
    },
  }), provideConfig(<I18nConfig>{
    i18n: {
      resources: { en: translationsEn },
      chunks: translationChunksConfig,
      fallbackLang: 'en'
    },
  }), provideConfig(<FeaturesConfig>{
    features: {
      level: '221121.4'
    }
  }),
  provideOutlet({
    id: 'cx-footer',
    position: OutletPosition.REPLACE,
    component: FooterComponent,
  }),
  ]
})
export class SpartacusConfigurationModule { }
